import React from "react";

const ItemsLoader = ({ cardCount = 5 }) => {
  return (
    <div className="item_loader">
      <div className="item_loader_header fade-in" />
      <div className="item_loader_fitler fade-in" />

      <div className="item_loader_body">
        {Array.from({ length: cardCount }).map((_, index) => (
          <div key={index} className="item_loader_card fade-in" />
        ))}
      </div>
    </div>
  );
};

export default ItemsLoader;